<template>
	<div class="container">
		<!--  顶部搜索  -->
		<search-bar ref="searchBar"></search-bar>
		<!--  分类选择列表  -->
		<div class="g-m-t-30">
			<sort-selection :list="sortList" ref="sortSelection" @changeParams='changeParams'></sort-selection>
		</div>
		<div class="g-flex g-row-center">
			<!--  列表/广告  -->
			<div class="g-m-t-30 g-row-between g-flex g-col-top total-width">
				<!--  列表  -->
				<div class="data-list">
					<div class="g-m-b-15 job-item" v-for="(item,index) in list " :key="index">
						<find-job-card @showResume="showResume" :item="item"></find-job-card>
					</div>
					<!--  分页  -->
					<div class="g-flex g-row-center g-m-t-30">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="params.current" :page-sizes="[10, 20, 30, 40]" :page-size="params.size"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</div>
				<!--  广告  -->
				<div class="ads">
					<a :href="item.target" target="_blank" v-for="(item,index) in imgList" :key="index">
						<img :src="item.imageUrl" class="ad" alt="">
					</a>
				</div>
			</div>
		</div>
		<!--  投递简历弹窗  -->
		<message-popup ref="popup" :showCancel="false" confirmText="知道了" @submit="doSubmit">
			<div class="g-text-center">
				<p class="g-m-t-10 main-text g-font-20">投递成功了!</p>
				<p class="g-m-t-20 remark-text g-font-14">已成功为您投递简历，请留意站内消息。</p>
			</div>
		</message-popup>
	</div>
</template>

<script>
	import searchBar from "@/components/search-bar";
	import sortSelection from "@/components/sort-selection";
	import findJobCard from "@/views/find-job/components/find-job-card";
	import messagePopup from "@/components/message-popup";
	import {
		jobList,
		portalList
	} from "@/api/job.js"
	import {
		regionTree,
		dictionary
	} from "@/api/api.js"
	import {
		getCarousel
	} from "@/api/home.js"
	export default {
		name: "find-job",
		components: {
			searchBar,
			sortSelection,
			findJobCard,
			messagePopup
		},
		data() {
			return {
				imgList: [],
				sortList: [{
						pId: 1,
						label: '选择城市',
						sublist: []
					},
					{
						pId: 2,
						label: '选择职业',
						sublist: []
					},
					{
						pId: 3,
						label: '工作年限',
						sublist: []
					},
					{
						pId: 4,
						label: '期望薪资',
						sublist: []
					},
					{
						pId: 5,
						label: '学历要求',
						sublist: []
					}
				],
				size: 10, //当前页
				total: 0,
				params: {
					province: '',
					city: '',
					county: '',
					postName: '',
					current: 1,
					size: 10,
					qualifications: '', //学历
					salary: '', //薪资
					postId: '',
					workYear: '',
					search: ''
				},
				list: [],
				regionList: [],
				diploma_list: [], //学历
				salary_list: [], //薪资
				working_seniority_list: [], //年限
				portalList: [] //职位
			}
		},
		watch: {
			'$route'(to, from) {
				console.log(to)
				this.params.search = to.query.s
				this.current = 1
				this.getJobList()
			}
		},
		mounted() {
			let queryWord = this.$route.query.s;
			if (queryWord && this.params.search != queryWord) {
				this.params.search = queryWord;
			}
			// 页面初始化时将默认菜单切换到搜职位
			this.$refs.searchBar.menuIndex = 1
			this.$refs.searchBar.keyword = queryWord
			this.getJobList()
			this.getDictionary('diploma')
			this.getDictionary('salary')
			this.getDictionary('working_seniority')
			this.getPortalList()
			this.getRegionTree()
			this.getImgList()

			let cacheUserInfo = this.$store.state.userInfo;
			if (!cacheUserInfo.realName ||
				!cacheUserInfo.sex ||
				!cacheUserInfo.phone ||
				!cacheUserInfo.workingSeniority ||
				!cacheUserInfo.diploma ||
				!cacheUserInfo.email ||
				!cacheUserInfo.wechat ||
				!cacheUserInfo.birthday) {
				this.$message.warning('请先完善个人信息')
				setTimeout(() => {
					this.$router.push({
						path: 'mine',
						query: {
							menuIndex: 0
						}
					})
				}, 1500);
				return;

			}
			if (cacheUserInfo.resumeId == -1 || cacheUserInfo.resumeId == '') {
				this.$message.warning('请先完善个人简历信息')
				setTimeout(() => {
					this.$router.push({
						path: 'mine',
						query: {
							menuIndex: 2
						}
					})
				}, 1500);
				return;
			}

		},

		methods: {
			getImgList() {
				getCarousel({
					classification: 'post',
					status: 2
				}).then(res => {
					this.imgList = res.records
				})
			},
			changeParams(e) {

				if (Array.isArray(e[0].subItem)) {
					this.params.county = e[0].subItem.map(a => {
						return a.dictKey
					}).toString()
				} else {
					this.params.county = e[0].subItem.dictKey
				}

				if (Array.isArray(e[1].subItem)) {
					this.params.postId = e[1].subItem.map(a => {
						return a.dictKey
					}).toString()
				} else {
					this.params.postId = e[1].subItem.dictKey
				}
				this.params.workYear = e[2].subItem.dictKey
				this.params.salary = e[3].subItem.dictKey
				this.params.qualifications = e[4].subItem.dictKey

				this.current = 1
				this.getJobList()

			},
			getRegionTree() {
				regionTree({}).then(res => {

					res.shift();
					this.regionList = JSON.parse(JSON.stringify(res).replace(/title/g, 'dictValue').replace(
						/value/g, 'dictKey'));
					this.sortList[0].sublist = this.regionList
					this.$refs.sortSelection.list = this.sortList;
					console.log('regionTree', this.sortList)

				})
			},
			getPortalList() {
				portalList({}).then(res => {
					console.log('getPortalList', res)
					this.portalList = JSON.parse(JSON.stringify(res).replace(/postName/g, 'dictValue').replace(
						/id/g, 'dictKey'));
					this.sortList[1].sublist = this.portalList
				})
			},
			getDictionary(type) {
				dictionary({
					code: type
				}).then(res => {
					this[type + '_list'] = res;
					if (type == 'diploma') {
						this.sortList[4].sublist = res
					}
					if (type == 'salary') {
						this.sortList[3].sublist = res
					}
					if (type == 'working_seniority') {
						this.sortList[2].sublist = res
					}
				})
			},

			getJobList() {
				jobList(
					this.params
				).then(res => {
					console.log('res', res)
					this.list = res.records
					this.total = res.total
				})
			},
			// 页数切换
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.params.size = val;
				this.getJobList()
			},
			// 当前页切换
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.params.current = val;
				this.getJobList()
			},
			// 打开投递简历弹窗
			showResume(e) {
				console.log(e)
				//todo...
				this.getJobList();
				this.$refs.popup.open()
			},
			// 投递简历确定事件
			doSubmit() {
				this.$refs.popup.close()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.ad {
		width: 285px;
		height: 166px;
		margin-bottom: 15px;
	}

	.job-item {
		width: 895px;
	}

	.submit-btn {
		padding: 6px 30px;

	}
</style>
